import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InputNumbersDirective } from "../components/directives/inputs/input-numbers.directive";
import { InputUppercaseDirective } from "../components/directives/inputs/input-uppercase.directive";
import { ButtonModule } from "primeng/button";
import { RippleModule } from "primeng/ripple";
import { SelectButtonModule } from "primeng/selectbutton";
import { DrawerModule } from "primeng/drawer";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { RadioButtonModule } from "primeng/radiobutton";
import { TooltipModule } from "primeng/tooltip";
import { StyleClassModule } from "primeng/styleclass";
import { InputTextModule } from "primeng/inputtext";
import { MegaMenuModule } from "primeng/megamenu";
import { BadgeModule } from "primeng/badge";
import { OverlayBadgeModule } from "primeng/overlaybadge";
import { CheckboxModule } from "primeng/checkbox";
import { PasswordModule } from "primeng/password";
import { InputGroupModule } from "primeng/inputgroup";
import { InputGroupAddonModule } from "primeng/inputgroupaddon";
import { ConfiguratorComponent } from "@/components/layout/configurator/configurator.component";
import { TranslateModule } from "@ngx-translate/core";
import { FloatLabelModule } from 'primeng/floatlabel';
import { DatatableComponent } from "@/components/datatable/datatable.component";
import { DropdownModule } from "primeng/dropdown";
import { InputFieldValidationComponent } from "@/components/form/inputs/input-field-validation/input-field-validation.component";
import { FiltersSidebarComponent } from "@/components/layout/filters-sidebar/filters-sidebar.component";
import { CardInfoPageComponent } from "@/components/layout/card/card-info-page/card-info-page.component";
import { MessageModule } from "primeng/message";
import { MessagesModule } from "primeng/messages";
import { CardModule } from "primeng/card";
import { MenuModule } from "primeng/menu";
import { ContextMenuModule } from "primeng/contextmenu";
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";
import { ToolbarModule } from "primeng/toolbar";
import { SidebarModule } from "primeng/sidebar";
import { SelectModule } from "primeng/select";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { ButtonsActionComponent } from "@/components/form/modals/buttons-action/buttons-action.component";
import { ConfirmDialogComponent } from "@/components/confirm-dialog/confirm-dialog.component";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { InputMaskModule } from "primeng/inputmask";
import { AccordionModule } from "primeng/accordion";
import { PickListModule } from "primeng/picklist";
import { LoadingComponent } from "@/components/loading/loading.component";
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { LeafletDrawModule } from '@bluehalo/ngx-leaflet-draw';
import { TextareaModule } from 'primeng/textarea';
import { InputFieldDirective } from "../components/directives/inputs/input-field.directive";
import { PasswordMatchValidatorDirective } from "../components/directives/inputs/password-match-validator.directive";
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleButtonModule } from "primeng/togglebutton";
import { StepsModule } from 'primeng/steps';
import { TabsModule } from 'primeng/tabs';
import { SliderModule } from 'primeng/slider';
import { PanelModule } from 'primeng/panel';
import { ChipsModule } from "primeng/chips";
import { FooterComponent } from "@/components/layout/footer/footer.component";
import { EditorModule } from 'primeng/editor';
import { ConfirmInputDataComponent } from "@/components/confirm-input-data/confirm-input-data.component";
import { DataViewModule } from 'primeng/dataview';
import { TagModule } from 'primeng/tag';
import { PopoverModule } from 'primeng/popover';
import { OverlayDatatableComponent } from "@/components/overlay-datatable/overlay-datatable.component";

const modules = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // NGX
    TranslateModule,
    LeafletModule,
    LeafletDrawModule,
    // PrimeNG Modules
    ButtonModule,
    RippleModule,
    SelectButtonModule,
    DrawerModule,
    ToggleSwitchModule,
    RadioButtonModule,
    TooltipModule,
    StyleClassModule,
    InputTextModule,
    MegaMenuModule,
    BadgeModule,
    OverlayBadgeModule,
    CheckboxModule,
    PasswordModule,
    InputGroupModule,
    InputGroupAddonModule,
    FloatLabelModule,
    DropdownModule,
    MessageModule,
    MessagesModule,
    CardModule,
    MenuModule,
    ContextMenuModule,
    TableModule,
    ToastModule,
    ToolbarModule,
    SidebarModule,
    SelectModule,
    ConfirmDialogModule,
    DialogModule,
    DynamicDialogModule,
    ProgressSpinnerModule,
    InputMaskModule,
    AccordionModule,
    PickListModule,
    TextareaModule,
    MultiSelectModule,
    InputNumberModule,
    ToggleButtonModule,
    StepsModule,
    TabsModule,
    SliderModule,
    PanelModule,
    ChipsModule,
    EditorModule,
    DataViewModule,
    TagModule,
    PopoverModule,
];

const components = [
    // Directives
    InputNumbersDirective,
    InputUppercaseDirective,
    InputFieldDirective,
    PasswordMatchValidatorDirective,
    // 
    // Components
    ConfiguratorComponent,
    // Layouts
    FooterComponent,
    // CotaGov
    DatatableComponent,
    OverlayDatatableComponent,
    InputFieldValidationComponent,
    FiltersSidebarComponent,
    CardInfoPageComponent,
    ButtonsActionComponent,
    ConfirmDialogComponent,
    ConfirmInputDataComponent,
    LoadingComponent,
];

@NgModule({
    declarations: [...components],
    imports: [...modules],
    exports: [...modules, ...components],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
